import styles from "./auth-gate-modal.module.css";
import { Modal } from "BEDROCK/shared-components/modal";
import { CTAButton } from "./cta-button";
import { usePaths } from "BEDROCK/paths";
import { useNavigate } from "react-router-dom";

interface AuthGateModalProps {
  isShowing: boolean;
  onDismiss: () => void;
  redirectPath?: string;
}

export const AuthGateModal = ({
  isShowing,
  onDismiss,
  redirectPath,
}: AuthGateModalProps) => {
  const { auth } = usePaths();
  const navigateTo = useNavigate();

  const handleSignUp = () => {
    const path = redirectPath
      ? `${auth}?redirect=${encodeURIComponent(
          redirectPath
        )}&continueProject=true`
      : auth;
    navigateTo(path);
  };

  const handleSignIn = () => {
    const path = redirectPath
      ? `${auth}?redirect=${encodeURIComponent(
          redirectPath
        )}&continueProject=true&signIn=true`
      : `${auth}?signIn=true`;
    navigateTo(path);
  };

  return (
    <Modal isOpen={isShowing} showCloseButton={true} onClose={onDismiss}>
      <div className={styles.container}>
        <h1>SAVE YOUR DESIGN</h1>
        <p>Sign up to save your poster design and order prints.</p>
        <p>
          Your work will be saved to your account
          <br />
          so you can come back to it later.
        </p>
        <div className={styles.ctaCol}>
          <CTAButton
            className={styles.cta}
            variant="PRIMARY"
            onClick={handleSignUp}
          >
            Sign up
          </CTAButton>
          <CTAButton
            className={styles.cta}
            variant="SECONDARY"
            onClick={handleSignIn}
          >
            Sign in
          </CTAButton>
          <button className={styles.continueLink} onClick={onDismiss}>
            Continue editing
          </button>
        </div>
      </div>
    </Modal>
  );
};
